import { render, staticRenderFns } from "./workerCertificateDoctorPraCount.vue?vue&type=template&id=ce8e5846&scoped=true&"
import script from "./workerCertificateDoctorPraCount.vue?vue&type=script&lang=js&"
export * from "./workerCertificateDoctorPraCount.vue?vue&type=script&lang=js&"
import style0 from "./workerCertificateDoctorPraCount.vue?vue&type=style&index=0&id=ce8e5846&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8e5846",
  null
  
)

export default component.exports